import { buildConfiguratorSearch } from "@cfg/configurator-ui";
import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router";
import { useApp } from "../app-context.tsx";
import { DefaultEmptyState } from "./defaults.tsx";

/** Public read-only share link: resolves the token and opens the configurator with those params. */
export function SharePage() {
  const { token = "" } = useParams();
  const { api, brand, copy } = useApp();
  const Empty = brand.slots?.EmptyState ?? DefaultEmptyState;
  const q = useQuery({ queryKey: ["share", token], queryFn: () => api!.getShared(token), enabled: !!api });
  if (!api)
    return (
      <section className="page page-share page-share-missing">
        <Empty title={copy("share.noApi")} body={copy("common.noApi")} />
      </section>
    );
  if (q.isLoading) return <p className="muted page">{copy("share.opening")}</p>;
  if (q.isError || !q.data)
    return (
      <section className="page page-share page-share-missing">
        <Empty
          title={copy("share.missing")}
          body={copy("share.missingBody")}
          action={
            <a className="cfg-btn cfg-btn-primary share-browse" href="/">
              {copy("share.browse")}
            </a>
          }
        />
      </section>
    );
  const s = q.data;
  return <Navigate to={`/design/${encodeURIComponent(s.designId)}${buildConfiguratorSearch({ version: s.version, params: s.params })}`} replace />;
}
